export const TitleListSort = {
	Sequence: 'sequence',
	Votes: 'votes',
};
